module.exports = __webpack_public_path__ + "static/media/shocks-shocks.e72d130a.svg";